import React from 'react'

import { Box, Stack } from 'primitives/containers'

import { MicrophoneOn2 } from '../../../../images'

export const RecordingToolbar = () => {
  return (
    <Stack
      gap="2"
      direction="row"
      css={{
        height: '$space$6',
        fontSize: '$3',
        lineHeight: '$1',
        flex: 1,
      }}
    >
      <Stack
        gap="1"
        direction="row"
        css={{
          borderRadius: '$2',
          backgroundColor: '$red500',
          color: 'white',
          fill: 'white',
          height: '100%',
          padding: '0 $1',
          minWidth: 95,
        }}
      >
        <MicrophoneOn2 />
        <span>On Air</span>
      </Stack>

      <Box
        css={{
          borderRadius: '$2',
          backgroundColor: '$red100',
          color: '$red900',
          height: '100%',
          padding: '0 $4',
          flexShrink: 1,
        }}
      >
        <Box truncate css={{ width: '100%' }}>
          Recording Audio Message...
        </Box>
      </Box>
    </Stack>
  )
}
